// extracted by mini-css-extract-plugin
export var carouselButton = "carousel-button-module--carouselButton--0f49a";
export var dark = "carousel-button-module--dark--0f134";
export var light = "carousel-button-module--light--5504a";